@if (_active) {
  <kendo-window
    #mainWindow
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : (_isEdit ? 'EDIT RECORD' : 'ADD NEW RECORD') }}"
    (close)="_closeForm(false)"
    [state]="_windowState"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm">
    <form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
      <!-- Section Header -->
      <div class="row">
        <div class="col-12">
          <div class="transaction-section-header">
            <div class="transaction-section-header-title">
              <div class="d-flex align-items-center">
                <span>Site Transfer Request</span>
                <span class="statusSection">
                  <span class="statusText">Status</span>
                  <label class="control-label statusLabel" [class.dispatched]="_isLocked">{{ _statusLabel }}</label>
                </span>
              </div>
            </div>
            <div class="transaction-section-header-actions header-actions">
              @if (!_isLocked && _pageState != 1) {
                <button class="hidden-xs asap-btn" kendoButton (click)="_onSubmit('save')" [disabled]="_saving">
                  <span>
                    <img [src]="'/assets/menu/'+ _theme +'/save-icon.svg'" onerror="this.src='/assets/menu/enterprise/save-icon.svg'" />
                  </span>Save
                </button>
                <button class="hidden-xs asap-btn" kendoButton (click)="_onSubmit('saveAndClose')" [disabled]="_saving">
                  <span>
                    <img [src]="'/assets/menu/'+ _theme +'/save-close-icon.svg'" onerror="this.src='/assets/menu/enterprise/save-close-icon.svg'" />
                  </span>Save & Close
                </button>
              }
              <button class="hidden-xs asap-btn" kendoButton (click)="_onCancel()">
                <span>
                  <img [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" onerror="this.src='/assets/menu/enterprise/close-icon.svg'" />
                </span>Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Lockout Alert -->
      @if (_isLocked) {
        <div class="row no-row-margin">
          <div class="col-12">
            <div class="alert alert-warning" style="margin: 10px 0;">
              <strong>Editing Locked:</strong> Dispatch has already commenced for this transfer request. Quantities and locations are locked to maintain chain of custody.
            </div>
          </div>
        </div>
      }

      <div class="row no-row-margin">
        <!-- Left Column: General Information -->
        <div class="col-12 col-lg-6 small-pad-right">
          <div class="transactionWidget">
            <div class="row">
              <div class="col-12 sectionheader">
                <p class="titleStandardStyle">General Information</p>
              </div>

              <!-- From Site -->
              <div class="col-12 margin-top-10">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-3">
                      <label class="control-label">From Site <span class="required" style="color: red;">*</span></label>
                    </div>
                    <div class="col-9 transaction-receive-input-fields">
                      <kendo-combobox
                        [data]="_filteredFromSites"
                        [textField]="'name'"
                        [valueField]="'id'"
                        [valuePrimitive]="true"
                        [suggest]="true"
                        [filterable]="true"
                        (filterChange)="_handleFromSitesFilter($event)"
                        (valueChange)="_onSiteFromChange($event)"
                        formControlName="siteFromId"
                        placeholder="Choose a Site"
                        [disabled]="_isSiteFromLocked || _isLocked || _pageState == 1"
                        class="bordered">
                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                          <span>{{ dataItem.name }} ({{ dataItem.code }})</span>
                        </ng-template>
                      </kendo-combobox>
                    </div>
                  </div>
                  @if (_isSiteFromLocked) {
                    <div class="row">
                      <div class="col-3"></div>
                      <div class="col-9">
                        <span class="field-hint" style="color: #64748b; font-size: 11px; display: block; margin-top: 3px;">Locked to your active site.</span>
                      </div>
                    </div>
                  }
                </div>
              </div>

              <!-- To Site -->
              <div class="col-12 margin-top-10">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-3">
                      <label class="control-label">To Site <span class="required" style="color: red;">*</span></label>
                    </div>
                    <div class="col-9 transaction-receive-input-fields">
                      <kendo-combobox
                        [data]="_filteredToSites"
                        [textField]="'name'"
                        [valueField]="'id'"
                        [valuePrimitive]="true"
                        [suggest]="true"
                        [filterable]="true"
                        (filterChange)="_handleToSitesFilter($event)"
                        formControlName="siteToId"
                        placeholder="Choose a Site"
                        [disabled]="_isLocked || _pageState == 1"
                        class="bordered">
                        <ng-template kendoComboBoxItemTemplate let-dataItem>
                          <span>{{ dataItem.name }} ({{ dataItem.code }})</span>
                        </ng-template>
                      </kendo-combobox>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Notes -->
              <div class="col-12 margin-top-10">
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-3">
                      <label class="control-label">Notes</label>
                    </div>
                    <div class="col-9 transaction-receive-input-fields">
                      <input
                        type="text"
                        class="k-textbox writebox"
                        formControlName="notes"
                        placeholder="Transaction Notes.."
                        [attr.disabled]="_isLocked || _pageState == 1 ? '' : null"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column: Select or Scan Stock Item # -->
        <div class="col-12 col-lg-6 small-pad-left">
          <div class="transactionWidget">
            <div class="row">
              <div class="col-12 sectionheader">
                <p class="titleStandardStyle">Select or Scan Stock Item #</p>
              </div>

              @if (_isLocked || _pageState == 1) {
                <div class="col-12">
                  <div class="alert alert-info" style="font-size: 12px; margin-top: 10px;">
                    Item adding is disabled in this mode.
                  </div>
                </div>
              }

              @if (!_isLocked && _pageState != 1) {
                <!-- Stock Item # -->
                <div class="col-12 margin-top-10">
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-3">
                        <label class="control-label">Stock Item #</label>
                      </div>
                      <div class="col-9 transaction-receive-input-fields">
                        <kendo-combobox
                          [data]="_filteredStockLocations"
                          [filterable]="true"
                          (filterChange)="_handleStockLocationsFilter($event)"
                          [(ngModel)]="_selectedStockLocation"
                          [ngModelOptions]="{standalone: true}"
                          [suggest]="true"
                          [placeholder]="_availableStockLocations.length === 0 ? 'No stock available' : 'Choose stock item...'"
                          [textField]="'displayLabel'"
                          [valueField]="'id'"
                          [disabled]="!_form.get('siteFromId')?.value || _availableStockLocations.length === 0"
                          class="bordered current-step newFormControlWidth">
                          <ng-template kendoComboBoxItemTemplate let-dataItem>
                            <div class="transactions-receive-stock-dropdown-item">
                              <div class="truncate">
                                <strong>{{ dataItem.itemNumber }}</strong>
                                @if (dataItem.itemDescription) {
                                  <span> | {{ dataItem.itemDescription }}</span>
                                }
                              </div>
                              <div class="transactions-receive-stock-dropdown-item-description truncate">
                                Loc: {{ dataItem.locationCode || 'N/A' }} | Avail: {{ dataItem.availableQuantity }}
                              </div>
                            </div>
                          </ng-template>
                        </kendo-combobox>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Transfer Quantity -->
                <div class="col-12 margin-top-10">
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-3">
                        <label class="control-label">Transfer Quantity</label>
                      </div>
                      <div class="col-9 transaction-receive-input-fields">
                        <kendo-numerictextbox
                          class="k-textbox writebox"
                          [min]="1"
                          [max]="_selectedStockLocation?.availableQuantity || 999999"
                          [(ngModel)]="_inputQuantity"
                          [ngModelOptions]="{standalone: true}"
                          (keyup.enter)="_addLineItem()"
                          (keydown.Tab)="_addLineItem()"
                          [disabled]="!_selectedStockLocation">
                        </kendo-numerictextbox>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Add to Transfer Button -->
                <div class="col-12 margin-top-10 text-right">
                  <button
                    type="button"
                    class="asap-btn"
                    kendoButton
                    (click)="_addLineItem()"
                    [disabled]="!_selectedStockLocation || !_inputQuantity || _inputQuantity <= 0">
                    <span>
                      <img [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" onerror="this.src='/assets/menu/enterprise/add-new-icon_grid.svg'" />
                    </span>
                    Add to Transfer
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom: Transfer Items Grid -->
      <div class="row no-row-margin">
        <div class="col-12">
          <div class="transactionWidget with-grid">
            <div class="flex-space-between transaction-receive-grid-header-wrapper">
              <p class="titleStandardStyle">
                Transfer Items ({{ _lineItems.length }})
              </p>
            </div>
            <div style="overflow-x: auto !important">
              <kendo-grid
                [data]="_lineItems"
                [scrollable]="'none'"
                class="transaction-receive-grid"
                (remove)="_removeHandler($event)">
                <ng-template kendoGridNoRecordsTemplate>
                  <div class="empty-grid-text">
                    No items added to this transfer yet. Select an available stock item above and click "Add to Transfer".
                  </div>
                </ng-template>

                <kendo-grid-column field="itemNumber" title="Stock Item #" [width]="180">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <strong>{{ dataItem.itemNumber }}</strong>
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="itemDescription" title="Stock Description">
                </kendo-grid-column>

                <kendo-grid-column field="locationCode" title="Location" [width]="140">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{ dataItem.locationCode }}</span>
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="availableQuantity" title="Available Qty" [width]="140" [headerStyle]="{ 'text-align': 'right' }" [style]="{ 'text-align': 'right' }">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.availableQuantity }}
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column field="quantity" title="Transfer Qty" [width]="160" [headerStyle]="{ 'text-align': 'right' }" [style]="{ 'text-align': 'right' }">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    @if (!_isLocked && _pageState != 1) {
                      <kendo-numerictextbox
                        class="transaction-receive-grid-quantity"
                        [value]="dataItem.quantity"
                        [min]="1"
                        [max]="dataItem.availableQuantity"
                        [autoCorrect]="true"
                        [format]="'#'"
                        (valueChange)="_onItemQuantityChange($event, dataItem)">
                      </kendo-numerictextbox>
                    } @else {
                      <span>{{ dataItem.quantity }}</span>
                    }
                  </ng-template>
                </kendo-grid-column>

                @if (_isEdit) {
                  <kendo-grid-column field="transferredQuantity" title="Transferred Qty" [width]="150" [headerStyle]="{ 'text-align': 'right' }" [style]="{ 'text-align': 'right' }">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <strong>{{ dataItem.transferredQuantity || 0 }}</strong>
                    </ng-template>
                  </kendo-grid-column>
                }

                @if (!_isLocked && _pageState != 1) {
                  <kendo-grid-command-column title="Action" [width]="120">
                    <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
                      <div kendoGridRemoveCommand class="asap-grid-remove">
                        <div class="asap-grid-remove-icon">
                          <img [src]="'/assets/menu/'+ _theme +'/remove-icon.svg'" onerror="this.src='/assets/menu/enterprise/remove-icon.svg'" />
                        </div>
                        <div class="asap-grid-remove-text">
                          Delete
                        </div>
                      </div>
                    </ng-template>
                  </kendo-grid-command-column>
                }
              </kendo-grid>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-window>
}
